import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  root: {
    zIndex: 1300,
    pointerEvents: "none",
  },
  content: {
    height: 24,
    padding: "0 8px",
    backgroundColor: `${theme.palette.text.primary} !important`,
    color: theme.props.text.alt,
    borderRadius: 5,
    flexDirection: "row !important",
    fontWeight: 600,
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15) !important",
  }
}));

export default useStyle;
